import * as React from 'react';
import ConfettiLib from 'react-dom-confetti';

import './styles/Confetti.scss';

const confettiConfig = {
  angle: -90,
  spread: 200,
  startVelocity: 20,
  elementCount: 150,
  decay: 0.95,
};

export default class Confetti extends React.Component<{}, { active: boolean }> {
  state: { active: boolean } = {
    active: false,
  };
  componentDidMount() {
    // Confetti will only show when the prop changes from false -> true.
    setTimeout(() => this.setState({ active: true }), 0);
  }
  render() {
    // ConfettiLib does not explicitly define a className prop, so we need to pass it in via a props object
    const otherProps = { className: 'Confetti' };
    return <ConfettiLib active={this.state.active} config={confettiConfig} {...otherProps} />;
  }
}
